import './Root.scss'
import { useGetSearchParam } from '../../hooks'
import { Navigate, Outlet } from 'react-router'
import { toast } from 'react-toastify'
import { useEffect } from 'react'
import { useSearchParams } from 'react-router-dom'

export function Root() {
  const authStatus = useGetSearchParam('authStatus')
  const [searchParams, setSearchParams] = useSearchParams()

  useEffect(() => {
    if (!authStatus) return

    const clearAuthStatus = () => {
      const updatedSearchParams = new URLSearchParams(searchParams)
      updatedSearchParams.delete('authStatus')
      setSearchParams(updatedSearchParams)
    }

    switch (authStatus) {
      case 'login-success':
        toast.success('Logged in successfully', {
          toastId: authStatus,
          autoClose: 1000,
          pauseOnHover: false,
          hideProgressBar: false,
          closeOnClick: true,
        })
        break
      case 'logout-success':
      case 'logout-failed': // sometimes the call to backend to logout fails but we still cleared the session
        toast.info('Logged out successfully', {
          toastId: authStatus,
          autoClose: 1000,
          pauseOnHover: false,
          hideProgressBar: false,
          closeOnClick: true,
        })
        break
      case 'login-failed':
        toast.error('There was an issue logging you on.  Please contact your administrator.', {
          toastId: authStatus,
          autoClose: 3000,
          pauseOnHover: false,
          hideProgressBar: false,
          closeOnClick: true,
        })
        break
    }
    clearAuthStatus()
  }, [authStatus, searchParams, setSearchParams])

  if (authStatus === 'login-failed') {
    return <Navigate to="/" replace />
  }

  return (
    <div className="ux-root">
      <Outlet />
    </div>
  )
}
